var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgTomtom(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M11.9058 22L14.5525 17.4283H9.25917L11.9058 22ZM11.9058 12.4867C10.95 12.4871 10.033 12.1083 9.35622 11.4333C8.67941 10.7584 8.29804 9.8425 8.29583 8.88667C8.29804 7.93083 8.67941 7.01493 9.35622 6.33999C10.033 5.66505 10.95 5.28622 11.9058 5.28667C12.8617 5.28622 13.7786 5.66505 14.4554 6.33999C15.1323 7.01493 15.5136 7.93083 15.5158 8.88667C15.5136 9.8425 15.1323 10.7584 14.4554 11.4333C13.7786 12.1083 12.8617 12.4871 11.9058 12.4867ZM11.9058 2C8.0975 2 5 5.08917 5 8.88667C5 12.6842 8.0975 15.7733 11.9058 15.7733C15.7142 15.7733 18.8117 12.6842 18.8117 8.88667C18.8117 5.08917 15.7133 2 11.9058 2Z",
    fill: "#DF1B12"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTomtom);
export default __webpack_public_path__ + "static/media/tomtom.4fbf16ae2dca2172c76bc7e792755207.svg";
export { ForwardRef as ReactComponent };